module.exports = "/_next/static/images/41bb35d98ebdbcbceb4fda45722a6205-nuconta-inclined-device@3x.png.webp";